<template>
  <v-app>
    <div id="app">
      <router-view/>
    </div>
  </v-app>
</template>

<script>
export default {
/*
  methods: {
    checkMbrs: function () {
      console.log("checkMembers called")
      this.showMbrs = this.$hasRole(['adm'])
    }
  },
  data() {
    return {
      showMbrs: this.$store.state.isLoggedIn
    }
  }
*/
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  color: blue;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: lightskyblue;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
